import { GET_CURRENT_CUSTOMER } from "../redux/apis";
import { loginFailure, loginSuccess } from "../redux/authReducer";
import { axiosAuthInstance } from "../redux/axiosInstance";
import { getCustomerCart } from "./cartUtils";

export const getLoggedInUser = async (isNavigate: boolean, dispatch: any, history: any) => {
    const token = localStorage.getItem("token");
    if (token) {
        const response: any = await axiosAuthInstance.get(GET_CURRENT_CUSTOMER);
        const data = response.data;
        if (data) {
            dispatch(loginSuccess(data));
            localStorage.setItem("customerId", data.customerId);
            localStorage.setItem("firstName", data.firstName);
            localStorage.setItem("lastName", data.lastName);
            localStorage.setItem("email", data.email);
            localStorage.setItem("mobileNumber", data.mobileNumber);
            getCustomerCart(dispatch);
            if (isNavigate) {
                history("/");
            }
        }
    }

};